import {
    GET_APPEARANCE_LOGOS_SUCCESS,
    UPLOAD_APPEARANCE_LOGO,
    UPLOAD_APPEARANCE_LOGO_SUCCESS,
    UPLOAD_APPEARANCE_LOGO_FAILURE,
    DELETE_APPEARANCE_LOGO,
    DELETE_APPEARANCE_LOGO_SUCCESS,
} from "./constants";

const initialState = {
    loading: false,
    logos: [],
    error: null,
};

const appearanceLogo = (state = initialState, action) => {
    switch (action.type) {
        case GET_APPEARANCE_LOGOS_SUCCESS:
            return { ...action.logos, logos: action.logos };
        case UPLOAD_APPEARANCE_LOGO:
            return { ...state, loading: true, error: null };
        case UPLOAD_APPEARANCE_LOGO_SUCCESS:
            return {
                ...state,
                loading: false,
                logos: [action.payload, ...state.logos],
                error: null,
            };
        case UPLOAD_APPEARANCE_LOGO_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case DELETE_APPEARANCE_LOGO:
            return { ...state, error: null };
        case DELETE_APPEARANCE_LOGO_SUCCESS:
            return {
                ...state,
                logos: state.logos.filter((logo) => logo.id != action.payload),
            };
        default:
            return state;
    }
};

export default appearanceLogo;
